import React from "react";

const FilesCard = ({ filesData = [] }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-8">
      {filesData.length > 0 ? (
        filesData.map((document, index) => (
          <div key={index} className="border border-grey-300 rounded-2xl p-8 flex flex-col items-center justify-center">
            <a href={document.file} target="_blank" rel="noreferrer">
              <div className="mb-2 text-5xl text-Success/700">
                <ion-icon name="document"></ion-icon>
              </div>
              <p className="pt-2 text-sm font-medium text-success-700 whitespace-nowrap">
                {document?.fileName.length > 15
                  ? `${document.fileName.slice(0, 15)}...`
                  : document.fileName}
              </p>
            </a>
          </div>

        ))
      ) : (
        <p className="text-center text-grey-500">No files available.</p>
      )}
    </div>
  );
};

export default FilesCard;

